import { render, staticRenderFns } from "./CustomerRedemptionsDialog.vue?vue&type=template&id=7b09a6f2"
import script from "./CustomerRedemptionsDialog.vue?vue&type=script&lang=js"
export * from "./CustomerRedemptionsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports